"use client";

import Link from "next/link";

export default function RefundPage() {
  return (
    <div className="min-h-screen bg-[#0b0b10] text-white">
      <div className="mx-auto w-full max-w-4xl px-4 py-10 sm:px-6 sm:py-16">
        <p className="text-[10px] uppercase tracking-[0.3em] text-white/60">
          Legal
        </p>
        <h1 className="mt-3 text-3xl font-heading text-white">Refund &amp; Cancellation Policy</h1>
        <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/70">
          <p className="font-medium text-white/80">Version 1.0</p>
          <p className="mt-1">Effective: February 2026</p>
        </div>

        <div className="mt-10 space-y-4 text-sm leading-relaxed text-white/70">
          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">1. General Refund Policy</h2>
            <p className="mt-3">
              This policy outlines the terms and conditions for refunds and cancellations on the Hopp platform operated by Innovation Hopp Experiences Private Limited.
            </p>
            <p className="mt-3">
              Hopp has the right, in its sole discretion, at any time to adjust, supplement, modify, revise, terminate, or carry out any necessary alterations to this refund and return process either entirely or partially.
            </p>
            <p className="mt-3">
              The terms set out herein shall be read in consonance with the respective terms and conditions including with respect to returns for each Merchant.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">2. Failed Transactions</h2>
            <p className="mt-3">
              In case you have made the payment but failed to receive any email, banner and/or SMS confirmation, then chances are that such a payment has failed. Once Hopp confirms a failed transaction, Hopp will endeavour to initiate the process for refunds.
            </p>
            <p className="mt-3">
              <strong className="text-white">Processing Time:</strong> While it may take 3-5 business days to initiate such a refund, it may take up to 7-10 business days (and sometimes more) for Hopp&apos;s payment service providers to credit the amount to your source account.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">3. Disputed Transactions</h2>
            <p className="mt-3">
              In case of a disputed transaction whereby you dispute any payment undertaken on the Platform, Hopp shall endeavour to refund the amount through the Platform after making reasonable efforts to verify the facts of such complaint/dispute with the Merchant and may at its sole discretion initiate the refund.
            </p>
            <p className="mt-3">
              For the sake of clarity, Hopp shall not be responsible or liable in any manner in case you visit the Store(s) for returning any products to the Merchant(s) or requesting for a refund without initiating the process on the Platform.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">4. Event Tickets</h2>

            <h3 className="mt-4 text-sm font-medium text-white">4.1 General Policy</h3>
            <p className="mt-2">
              <strong className="text-red-400">Tickets once sold cannot be exchanged, cancelled, modified, transferred, or refunded</strong> unless the Merchant has specified so in the Event&apos;s terms and conditions. Please make sure you check the date, time, and location before you book your tickets.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">4.2 Event Cancellation by Merchant</h3>
            <p className="mt-2">
              If an Event is cancelled and the Merchant of such Event agrees on issuing a refund for the tickets, it shall be the Merchant&apos;s responsibility to instruct Hopp to communicate and contact you and process the refund. Hopp shall have no liability in this regard.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">4.3 Event Postponement</h3>
            <p className="mt-2">
              If an Event gets postponed to a later date, the Merchant at its sole discretion may give you an option to attend the Event on a rescheduled date or if you don&apos;t wish to attend the Event you may avail a refund within a specific duration communicated to you by Hopp.
            </p>
            <p className="mt-2">
              Upon successfully filling the relevant details required for the refund, you will be provided a refund. Any request for refund post the expiry of duration will be solely at Merchant&apos;s discretion. However, the booking fee charged by Hopp is non-refundable.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">4.4 Refund Processing</h3>
            <p className="mt-2">
              If the Merchant informs Hopp to process the refunds on their behalf, your refunds may reflect in your account within <strong className="text-white">seven (7) to ten (10) working days</strong> from the date of receiving the refund request.
            </p>
            <p className="mt-2">
              Hopp reserves the right to deny refunds for tickets purchased outside of the Platform. Any decisions taken by the Merchant and Hopp will be final and binding in this regard.
            </p>

            <div className="mt-4 rounded-xl bg-red-500/10 border border-red-500/20 p-4">
              <p className="font-semibold text-red-400">Ticket Resale Warning</p>
              <p className="mt-2 text-white/60 text-xs">
                ANY TICKET PURCHASED THROUGH THE PLATFORM IS MEANT SOLELY AND EXCLUSIVELY FOR PERSONAL USE BY THE PERSON IN WHOSE NAME THE TICKET HAS BEEN ISSUED. TICKETS ARE NOT A TRANSFERABLE PROPERTY AND CANNOT BE RESOLD, TRANSFERRED OR CONVEYED TO ANY PERSON UNLESS PRIOR WRITTEN AND EXPRESS PERMISSION HAS BEEN PROVIDED BY THE MERCHANT.
              </p>
            </div>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">5. Table Reservations</h2>

            <h3 className="mt-4 text-sm font-medium text-white">5.1 Cancellation Window</h3>
            <p className="mt-2">
              A confirmed booking for which Booking Fee has been charged from you, modification option will not be available. However, you&apos;re required to cancel the confirmed booking <strong className="text-white">twenty-four (24) hours prior</strong> to the scheduled booking time to avail the refund.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">5.2 Refund Processing</h3>
            <p className="mt-2">
              Unless otherwise provided, Hopp shall refund the Booking Fee to you within <strong className="text-white">seven (7) working days</strong> from the date of such cancellation. However, Hopp reserves the right to retain the Booking Fee in the event you fail to cancel the booking within the estimated timeframe mentioned above.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">5.3 Late Arrivals</h3>
            <p className="mt-2">
              Hopp advises the Customer to arrive ten (10) minutes in advance of the scheduled booking time. The Merchant reserves the right to cancel your booking and allocate the table to other guests in case of late arrivals.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">5.4 Dispute Resolution</h3>
            <p className="mt-2">
              In the event the Merchant fails to honour the confirmed booking or in case of any other complaint or dispute raised by you in relation to the booking, you shall raise such disputes with Hopp <strong className="text-white">within thirty (30) minutes</strong> from the scheduled booking time.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">6. Offers, Deals &amp; Experiences</h2>

            <h3 className="mt-4 text-sm font-medium text-white">6.1 Cover Charge Refunds</h3>
            <p className="mt-2">
              A confirmed booking for which Cover Charge has been charged from you, modification option will not be available. However, you&apos;re required to cancel the confirmed booking <strong className="text-white">twenty-four (24) hours prior</strong> to the scheduled booking time to avail the refund.
            </p>
            <p className="mt-2">
              Unless otherwise provided, Hopp shall refund the Cover Charge to the Customer within <strong className="text-white">seven (7) working days</strong> from the date of such cancellation.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">6.2 Dispute Resolution</h3>
            <p className="mt-2">
              In the event the Merchant fails to honour the confirmed booking/Deal or in case of any other complaint or dispute raised by you in relation to the booking/Deal, you shall raise such disputes with Hopp <strong className="text-white">within thirty (30) minutes</strong> from the scheduled booking time.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">7. Sports Facilities &amp; Activities</h2>

            <h3 className="mt-4 text-sm font-medium text-white">7.1 Cancellation by Customer</h3>
            <p className="mt-2">
              Customers may cancel their slot bookings through the Platform, subject to the following refund structure:
            </p>

            <div className="mt-4 -mx-2 overflow-x-auto px-2">
              <table className="w-full min-w-[320px] text-xs">
                <thead>
                  <tr className="border-b border-white/10">
                    <th className="py-3 pr-4 text-left text-white">Time Before Slot Start</th>
                    <th className="py-3 text-left text-white">Refund Eligibility</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-white/10">
                    <td className="py-3">More than 24 hours</td>
                    <td className="py-3 text-green-400">100% refund of the base booking price</td>
                  </tr>
                  <tr className="border-b border-white/10">
                    <td className="py-3">12 to 24 hours</td>
                    <td className="py-3 text-yellow-400">50% refund of the base booking price</td>
                  </tr>
                  <tr>
                    <td className="py-3">0 to 12 hours / No-show</td>
                    <td className="py-3 text-red-400">No refund</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="mt-3 text-xs text-white/60">
              Note: &apos;Convenience fee&apos;, if any, charged by Hopp shall not be refunded.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">7.2 Cancellation by Merchants/Facilities</h3>
            <p className="mt-2">
              In the event the Merchant cancels the slot due to operational reasons, weather, technical failures, or overbooking, Customers will receive a <strong className="text-green-400">100% refund</strong>.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">7.3 Refund Processing</h3>
            <p className="mt-2">
              Refunds will be processed within <strong className="text-white">5-7 business days</strong> back to the original payment source.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">8. Movie Tickets</h2>

            <h3 className="mt-4 text-sm font-medium text-white">8.1 General Policy</h3>
            <p className="mt-2">
              Bookings for the tickets once made by you cannot be cancelled, modified, exchanged or refunded unless such policies are provided at the cinema or Platform and opted-in by you while booking the movie tickets.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">8.2 Cinema Cancellation Policy</h3>
            <p className="mt-2">
              Merchants (Cinema/theatre partners) may choose to provide flexibility of movie ticket cancellation at their own discretion. Benefits of Merchant&apos;s cancellation policy would be passed on to you on &quot;as-is&quot; basis and Hopp has no rights/control on the cancellation policy of the Merchants.
            </p>

            <h3 className="mt-4 text-sm font-medium text-white">8.3 Refund Deductions</h3>
            <p className="mt-2">Refund received for the cancelled booking (if any) will be after deduction of:</p>
            <ul className="mt-2 list-disc space-y-1 pl-5 marker:text-white/50">
              <li>Cancellation charges</li>
              <li>Booking charges</li>
              <li>Internet handling charges</li>
              <li>Food vouchers &amp; 3D glass charges</li>
              <li>Applicable taxes &amp; promotional benefits</li>
            </ul>

            <h3 className="mt-4 text-sm font-medium text-white">8.4 Important Notes</h3>
            <ul className="mt-2 list-disc space-y-1 pl-5 marker:text-white/50">
              <li>Partial cancellation of an order/booking/ticket(s) is not allowed</li>
              <li>Benefits of any applied promocode will be considered as redeemed if tickets are cancelled</li>
              <li>If cancellation is unsuccessful, the booking will be considered valid</li>
            </ul>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">9. Pay via Platform (Dining Out &amp; Stores)</h2>
            <p className="mt-3">
              In the event of a concern raised regarding the payment via the Platform, we shall use our best endeavours to assist you however such payment shall be subject to verification and confirmation from the respective Merchant.
            </p>
            <p className="mt-3">
              Upon receipt of such a complaint or dispute, Hopp will make reasonable efforts to verify the facts of such complaint/dispute with the Merchant and may at its sole discretion initiate the refund up to the Invoice Value to such Customer.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">10. Gift Cards</h2>
            <p className="mt-3">
              Hopp shall not be responsible or liable in any manner whatsoever for redemption of gift cards and grievances pertaining to redemption of gift cards shall be sent to and handled by the Merchant(s) directly.
            </p>
            <p className="mt-3">
              If you have accidentally purchased the wrong gift card, purchased a gift card for a Merchant other than intended, or selected an incorrect amount, your eligibility for a refund will be subject to the gift card issuer&apos;s respective policies.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">11. How to Request a Refund</h2>
            <p className="mt-3">To request a refund:</p>
            <ol className="mt-3 list-decimal space-y-2 pl-5 marker:text-white/50">
              <li>Log in to your Hopp account</li>
              <li>Go to &quot;My Bookings&quot; or &quot;My Payments&quot;</li>
              <li>Find the relevant booking and click &quot;Request Refund&quot;</li>
            </ol>
            <p className="mt-3">
              Alternatively, contact our support team at{" "}
              <a className="text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                info@hopp.life
              </a>{" "}
              with your booking details.
            </p>
          </section>

          <section className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <h2 className="text-base font-semibold text-white">12. Contact Us</h2>
            <p className="mt-3">
              For any questions about this refund policy or to request assistance:
            </p>
            <div className="mt-4 space-y-2">
              <p><span className="text-white/50">Legal Entity:</span> <span className="text-white">Innovation Hopp Experiences Private Limited</span></p>
              <p><span className="text-white/50">CIN:</span> <span className="text-white">U62099RJ2026PTC110279</span></p>
              <p><span className="text-white/50">Address:</span> <span className="text-white">1101, Tower Crest Wing-1, Chandra Kala Colony, Durgapura, Jaipur, Rajasthan - 302018, India</span></p>
              <p><span className="text-white/50">Email:</span>{" "}
                <a className="text-[var(--hopp-gold)] hover:underline" href="mailto:info@hopp.life">
                  info@hopp.life
                </a>
              </p>
            </div>

            <div className="mt-6 rounded-xl bg-white/5 p-5">
              <p className="font-semibold text-white">Grievance Officer &amp; Nodal Officer</p>
              <div className="mt-2 space-y-1">
                <p><span className="text-white/50">Name:</span> <span className="text-white">Nishchay Tolani</span></p>
                <p><span className="text-white/50">Email:</span>{" "}
                  <a className="text-[var(--hopp-gold)] hover:underline" href="mailto:nishchaytolani@hopp.life">
                    nishchaytolani@hopp.life
                  </a>
                </p>
                <p><span className="text-white/50">Hours:</span> <span className="text-white">Monday - Friday (09:00 a.m. to 18:00 p.m.)</span></p>
              </div>
            </div>
          </section>

          <section className="rounded-2xl border border-[var(--hopp-gold)]/30 bg-[var(--hopp-gold)]/5 p-6">
            <h2 className="text-base font-semibold text-white">Quick Links</h2>
            <div className="mt-3 flex flex-wrap gap-3">
              <Link href="/legal/terms" className="rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm hover:bg-white/10 transition-colors">
                Terms of Service
              </Link>
              <Link href="/legal/privacy" className="rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm hover:bg-white/10 transition-colors">
                Privacy Policy
              </Link>
              <Link href="/contact" className="rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm hover:bg-white/10 transition-colors">
                Contact Us
              </Link>
              <Link href="/about" className="rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm hover:bg-white/10 transition-colors">
                About Us
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
